import { Box, IconButton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ThemeColors, ThemeGradients } from 'src/styles';

export const Wrapper = styled(Box)(() => ({
  position: 'relative',
  border: '3px solid transparent',
  backgroundClip: 'padding-box',
  borderRadius: 16,
  backgroundColor: ThemeColors.white,
  marginBottom: 16,

  '&:after': {
    position: 'absolute',
    top: -3,
    left: -3,
    right: -3,
    bottom: -3,
    background: ThemeGradients.bg,
    content: '""',
    zIndex: -1,
    borderRadius: 16,
  },
}));

export const TitleStack = styled(Stack)(() => ({
  borderRadius: '13px 13px 0 0',
  backgroundColor: ThemeColors.black,
  flexDirection: 'row',
  justifyContent: 'center',

  '&:before': {
    content: '""',
    marginRight: 'auto',
    visibility: 'hidden',
    width: 36,
  },
}));

export const Title = styled(Typography)(() => ({
  fontSize: '1.062rem',
  lineHeight: '22px',
  fontWeight: 600,
  textTransform: 'uppercase',
  color: ThemeColors.white,
  textAlign: 'center',
  padding: '10px 0',
}));

export const InfoButton = styled(IconButton)(() => ({
  color: ThemeColors.white,
  marginLeft: 'auto',

  svg: {
    fill: 'currentColor',
  },
}));

export const MiningBox = styled(Box)(() => ({
  padding: 16,
  borderTop: `1px solid ${ThemeColors.grayLight}`,
}));

export const MiningBoxTitle = styled(Typography)(() => ({
  fontSize: '1.062rem',
  lineHeight: '22px',
  fontWeight: 600,
  textAlign: 'center',
  marginBottom: 12,
}));
